module.exports = __webpack_public_path__ + "img/exam-end.be5fc473.png";